<nav class="navbar navbar-expand-lg navbar-light fixed-top" aria-label="Main navigation">
    <a class="logo-container" routerLink="" data-toggle="collapse" data-target=".navbar-collapse.show"
        routerLinkActive="active">
        <img class="pr-2 noFocus" src="../assets/images/icons/decifris.svg" alt="Logo De Cifris">
    </a>
    <button mat-icon-button class="navbar-toggler" type="button" (click)="toggleSidebar()"
        aria-labelledby="dropdownMenuTogglerButton">
        <mat-icon style="color: white!important;">menu</mat-icon>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
            <!-- MENU WELCOME -->
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" routerLink="/welcome" id="welcomeDropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-labelledby="welcomeDropdownMenuLink" style="color: white; font-weight: 600;">Welcome</a>
                <div class="dropdown-menu" aria-labelledby="welcomeDropdownMenuLink">
                    <a class="dropdown-item" routerLink="/welcome/ricercatori" aria-labelledby="welcomeDropdownItem1"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Fai ricerca?</a>
                    <a class="dropdown-item" routerLink="/welcome/azienda" aria-labelledby="welcomeDropdownItem2"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Lavori in azienda?</a>
                    <a class="dropdown-item" routerLink="/welcome/insegnanti" aria-labelledby="welcomeDropdownItem3"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Insegni a scuola?</a>
                    <a class="dropdown-item" routerLink="/welcome/studenti" aria-labelledby="welcomeDropdownItem4"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Sei studente?</a>
                    <a class="dropdown-item" routerLink="/welcome/curiosi" aria-labelledby="welcomeDropdownItem5"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Ti incuriosisce?</a>
                </div>
            </li>
            <!-- MENU ASSOCIAZIONE -->
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" routerLink="/associazione" id="associazioneDropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-labelledby="associazioneDropdownMenuLink"
                    style="color: white; font-weight: 600;">Associazione</a>
                <div class="dropdown-menu" aria-labelledby="associazioneDropdownMenuLink">
                    <a class="dropdown-item" routerLink="/associazione/statuto"
                        aria-labelledby="associazioneDropdownItem1" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Statuto</a>
                    <a class="dropdown-item" routerLink="/associazione/regolamento"
                        aria-labelledby="associazioneDropdownItem2" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Regolamenti</a>
                    <a class="dropdown-item" routerLink="/associazione/organi-direttivi"
                        aria-labelledby="associazioneDropdownItem3" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Organi direttivi</a>
                    <a class="dropdown-item" routerLink="/associazione/advisory-board"
                        aria-labelledby="associazioneDropdownItem4" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Advisory board</a>
                        <a class="dropdown-item" routerLink="/associazione/affiliati-partner"
                            aria-labelledby="associazioneDropdownItem4bis" data-toggle="collapse"
                            data-target=".navbar-collapse.show">Affiliati e partner</a>
                    <a class="dropdown-item" routerLink="/associazione/associarsi"
                        aria-labelledby="associazioneDropdownItem5" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Come associarsi</a>
                    <mat-divider></mat-divider>
                    <a class="dropdown-item" routerLink="/associazione/posizioni-ricerca"
                        aria-labelledby="associazioneDropdownItem6" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Posizioni accademiche</a>
                    <a class="dropdown-item" routerLink="/associazione/scholarships"
                        aria-labelledby="associazioneDropdownItem7" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Scholarships</a>
                    <a class="dropdown-item" routerLink="/associazione/stage-tirocini"
                        aria-labelledby="associazioneDropdownItem7" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Stage e tirocini</a>
                    <mat-divider></mat-divider>
                    <a class="dropdown-item" routerLink="/associazione/notizie"
                        aria-labelledby="associazioneDropdownItem8" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Notizie</a>
                    <a class="dropdown-item" routerLink="/associazione/dicono-di-noi"
                        aria-labelledby="associazioneDropdownItem9" data-toggle="collapse"
                        data-target=".navbar-collapse.show">Dicono di noi</a>
                </div>
            </li>
            <!-- MENU ATTIVITA -->
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" routerLink="/attivita" id="attivitaDropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-labelledby="attivitaDropdownMenuLink" style="color: white; font-weight: 600;">Attività</a>
                <div class="dropdown-menu" aria-labelledby="attivitaDropdownMenuLink">
                    <a class="dropdown-item" routerLink="/attivita/eventi" aria-labelledby="attivitaDropdownItem1"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Eventi</a>
                    <a class="dropdown-item" routerLink="/attivita/corsi" aria-labelledby="attivitaDropdownItem2"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Corsi</a>
                    <a class="dropdown-item" routerLink="/attivita/seminari" aria-labelledby="attivitaDropdownItem3"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Seminari</a>
                    <a class="dropdown-item" routerLink="/attivita/editoria" aria-labelledby="attivitaDropdownItem4"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Editoria</a>
                </div>
            </li>
            <!-- MENU Koine -->
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" routerLink="/koine" id="koineDropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-labelledby="koineDropdownMenuLink" style="color: white; font-weight: 600;">Koine</a>
            </li>
            <!-- MENU CIFRIS25 -->
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" routerLink="/cifris25" id="cifris25DropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-labelledby="cifris24DropdownMenuLink" style="color: white; font-weight: 600;">CIFRIS25</a>
                <div class="dropdown-menu" aria-labelledby="cifris25DropdownMenuLink">
                    <a class="dropdown-item" routerLink="/cifris25/" aria-labelledby="cifris25DropdownItem1"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Home</a>
                    <a class="dropdown-item" routerLink="/cifris25/program" aria-labelledby="cifris25DropdownItem2"
                       data-toggle="collapse" data-target=".navbar-collapse.show">Program</a>
		    <a class="dropdown-item" routerLink="/cifris25/registration" aria-labelledby="cifris25DropdownItem3"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Registration</a>
                    <a class="dropdown-item" routerLink="/cifris25/workshops" aria-labelledby="cifris25DropdownItem4"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Workshops</a>
                    <a class="dropdown-item" routerLink="/cifris25/venue" aria-labelledby="cifris25DropdownItem5"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Venue</a>
                    <a class="dropdown-item" routerLink="/cifris25/proceedings" aria-labelledby="cifris25DropdownItem6"
                        data-toggle="collapse" data-target=".navbar-collapse.show">Proceedings</a>
                    
                </div>
            </li>
            <!-- MENU IXH -->
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" routerLink="/ixh25" id="koineDropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-labelledby="ixh25DropdownMenuLink" style="color: white; font-weight: 600;">IXH25</a>
            </li>
            <!-- MENU corso -->
             <!--
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" routerLink="/modcrypto26" id="koineDropdownMenuLink"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                    aria-labelledby="ixh25DropdownMenuLink" style="color: white; font-weight: 600;">MODCRYPTO26</a>
            </li>
            --> 
        </ul>
        <div style="position:absolute;right:0; margin-right: 30px;">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="mailing-list" aria-label="Mailing List" data-toggle="collapse"
                        data-target=".navbar-collapse.show" style="color: white; font-weight: 600;">Mailing List</a>
                </li>
                <li class="nav-item" routerLinkActive="active">
                    <a class="nav-link" routerLink="contatti" aria-label="Contatti" data-toggle="collapse"
                        data-target=".navbar-collapse.show" style="color: white; font-weight: 600;">Contatti</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
